import { Controller } from '@hotwired/stimulus';

export default class TaxLocationController extends Controller {
  static targets = [
    'toggle',
    'taxLocationContainer',
    'nifContainer',
    'nifInput',
    'taxCountry',
    'mainCountry',
    'destroyFlag',
  ];

  connect() {
    this.updateVisibility();
  }

  updateVisibility() {
    this.#updateTaxLocationVisibility();
    this.#updateNifVisibility();
  }

  updateNif() {
    this.#updateNifVisibility();
  }

  #updateTaxLocationVisibility() {
    const isDifferent = this.toggleTarget.checked;
    this.taxLocationContainerTarget.classList.toggle('d-none', !isDifferent);
    this.destroyFlagTarget.value = isDifferent ? '0' : '1';
  }

  #updateNifVisibility() {
    const mainCountry = this.mainCountryTarget.value;
    const isDifferent = this.toggleTarget.checked;
    const effectiveTaxCountry = isDifferent ? this.taxCountryTarget.value : mainCountry;

    const mainIsFrance = !!mainCountry && mainCountry.toUpperCase() === 'FR';
    const taxIsFrance = !!effectiveTaxCountry && effectiveTaxCountry.toUpperCase() === 'FR';
    const isNonFrench = !mainIsFrance || !taxIsFrance;

    this.nifContainerTarget.classList.toggle('d-none', isNonFrench);
    this.nifInputTarget.required = !isNonFrench;
  }
}
